<template>
  <div>
    <div class="md:min-h-[calc(100dvh-70px)] pb-14 pt-10 maxXs:pb-20 relative z-0 flex justify-center lg:items-center">
      <div v-if="showLoginForm" class="relative max-w-[580px] max-h-[690px] h-full w-[96%] md:w-full">
        <form v-on:submit.prevent="validateCaptcha('')" class="relative z-10 bg-white rounded-lg shadow-md px-5 md:px-8 py-12">
          <p v-html="$t('login_to_your_account').tTitle()" class="text-blue font-display font-bold md:text-4xl text-3xl text-center mb-12"></p>
          <p class="">
            <label class="block font-body">{{ $t('email').tTitle() }}</label>
            <input
              v-model="data.body.email"
              class="rounded-md w-full p-3 bg-gray-400 placeholder-gray-300 focus:outline-none border-none"
              type="email"
              placeholder="Email"
              autocomplete="email"
              name="email"
            />
          </p>

          <p class="mt-4">
            <label class="block label">{{ $t('password').tTitle() }}</label>
            <input
              class="rounded-md w-full p-3 bg-gray-400 placeholder-gray-300 focus:outline-none"
              type="password"
              placeholder="Password"
              v-model="data.body.password"
              autocomplete="current-password"
              name="current-password"
            />
          </p>

          <div class="mt-4 flex flex-row justify-between">
            <!-- remember me check box -->
            <div>
              <input
                class="checkbox"
                :class="{ 'appearance-none': data.body.rememberMe == '' }"
                type="checkbox"
                id="chk-rem-me"
                name="chk-rem-me"
                value=""
                v-model="data.body.rememberMe"
              />
              <label class="checkbox-label-xs" for="chk-rem-me" id="lbl-rem">{{ $t('remember_me') }}</label>
            </div>

            <!-- Forgot your password? -->
            <div>
              <router-link class="mt-1 ml-auto forgotPassword font-body text-xs text-gray-900" id="lnk-forgot-pass" :to="'/' + (Language || 'en') + '/forgot-password'">{{
                $t('forgot_password_q').tTitle()
              }}</router-link>
            </div>
          </div>

          <!-- Login button -->
          <div class="flex flex-wrap justify-center mt-8">
            <Button type="submit" mode="secondary" customClasses="!w-[248px]">
              {{ $t('login').tTitle() }}
            </Button>
          </div>

          <hr class="mt-8 border-t-2 border-gray-400" />

          <div class="flex flex-wrap justify-center mt-5">
            <h4 class="font-body font-bold text-xs sm:text-sm text-gray-900">{{ $t('not_registered_with_question').tTitle() }}</h4>
          </div>
          <!-- open live a/c -->
          <div class="flex flex-wrap justify-center mt-5 items-center gap-2">
            <router-link id="btn-ete-open-live" class="font-body font-bold text-blue text-xs sm:text-sm" :to="liveRegisterRoute">{{
              $t('open_live_account').tCapitalizeFirstLetter()
            }}</router-link>
            <div class="h-[14px] bg-gray-900 w-[1px]"></div>
            <!-- open demo a/c -->
            <router-link id="btn-ete-open-demo" class="font-body font-bold text-xs sm:text-sm text-gray-900" :to="demoRegisterRoute">{{
              $t('open_demo_account').tCapitalizeFirstLetter()
            }}</router-link>
          </div>

          <hr class="mt-5 border-t-2 border-gray-400" />
          <!-- To see how we use your data, please review our -->
          <div class="text-center mt-8">
            <div class="font-body text-xs text-gray-900">
              <span id="spn-your-data">{{ $t('risk_sentence') }}</span>
              <a class="font-bold ltr:pl-1 rtl:pr-1 text-gray-900" :href="privacyPolicyLink" target="_blank">{{ $t('privacy_policy').tTitle() }}</a>
            </div>
          </div>
        </form>
        <img class="absolute top-[-60px] md:left-[-60px] left-0 z-0" width="185" height="140" src="../../assets/img/login/plexy-login-dots.svg" />
        <img class="md:block hidden md:absolute bottom-[120px] left-[-60px] z-0" width="404" height="135" src="../../assets/img/login/plexy-login-yellow.svg" />
        <img class="md:block hidden md:absolute top-[100px] right-[-80px] z-0" width="313" height="232" src="../../assets/img/login/plexy-login-blue.svg" />
        <img class="absolute bottom-[-20px] md:right-[-60px] right-0 z-0" width="185" height="140" src="../../assets/img/login/plexy-login-dots.svg" />

      </div>
        <two-factor-modal-step-1
          v-if="TwoFactorAuthStep1.active"
          :TwoFactorAuthStep1="TwoFactorAuthStep1"
          @twoFactorStep2="showTwoFactorAuthStep2"
          @back="backToLogin"
        ></two-factor-modal-step-1>

        <two-factor-modal-step-2
          v-if="TwoFactorAuthStep2.active"
          :TwoFactorAuthStep2="TwoFactorAuthStep2"
          :data="data.body"
          :is2FASetup="is2FASetup"
          @back="goBack"
        ></two-factor-modal-step-2>

    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import config from '../../config'
import { Base64 } from 'js-base64'
import links from '../../config/links'
import TwoFactorModalStep1 from '@/components/2FA/Step1.vue'
import TwoFactorModalStep2 from '@/components/2FA/Step2.vue'
import Button from '@/components/reusableComponents/Button.vue'

export default {
  components: {
    TwoFactorModalStep1,
    TwoFactorModalStep2,
    Button,
  },
  data() {
    return {
      data: {
        body: {
          email: null,
          password: '',
          rememberMe: '',
          recaptchaToken: null,
        },
      },
      error: null,
      passwordValue: '',
      TwoFactorAuthStep1: {
        active: false,
        totp: '',
      },
      TwoFactorAuthStep2: {
        active: false,
      },
      showLoginForm: true,
      is2FASetup: false,
      hasSpace: false,
    }
  },
  computed: {
    websiteURL() {
      return config.URL.website
    },
    ...mapGetters({
      Language: 'language/code',
    }),
    passwordValueAsterisk() {
      let string = ''
      for (let i = 0; i < this.data.body.password.length; i++) {
        string += '*'
      }
      return string
    },
    privacyPolicyLink() {
      return links.getLink('privacyPolicy', 'en')
    },
    liveRegisterRoute() {
      return `/${this.Language || 'en'}/register/live`
    },
    demoRegisterRoute() {
      return `/${this.Language || 'en'}/register/demo`
    },
  },
  mounted() {
    this.$bus.$emit('ChangeHeadings', this.$t('login_to_your_account').tTitle(), null)
    this.addMeta('ogtitle', this.$t('login_to_your_account').tCapitalizeFirstLetter() + ' | ' + this.$t('app_name'))
    this.addMeta('description', this.$t('login_description'))
    this.addMeta('canonical', config.URL.cp + this.$route.path)
    this.addMeta('alternate', this.$route.meta.identifierPath)

    if (!this.$auth.check()) {
      this.$bus.$emit('LiveFeedClose')
    }
    // phone verification event
    // this.$bus.$on('otpPassed', this.otpPassed)
  },
  methods: {
    passwordChanged(pass) {
      let passLength = pass.target.value.length
      let newCharacter = pass.target.value.replaceAll('*', '')
      if (this.data.body.password.length - pass.target.value.length < -3) {
        this.data.body.password = ''
      } else {
        this.data.body.password += newCharacter
        if (this.data.body.password.length !== passLength) {
          this.data.body.password = this.data.body.password.substring(0, passLength)
        }
      }
    },
    validateCaptcha(totp = '') {
      this.$recaptchaLoaded()
      this.recaptchaToken = this.$recaptcha('login')

      this.recaptchaToken
        .then(value => {
          this.login(value, totp)
        })
        .catch(err => {
          console.log(err)
        })
    },
    changeLang(event) {
      this.$bus.$emit('ChangeLang', event)
    },
    check2FA(totp) {
      this.showLoginForm = false
      this.TwoFactorAuthStep1.active = true
      this.TwoFactorAuthStep1.totp = totp
    },
    showTwoFactorAuthStep2() {
      this.showLoginForm = false
      this.TwoFactorAuthStep1.active = false
      // this.TwoFactorAuthStep1.totp = ''
      this.TwoFactorAuthStep2.active = true
    },
    login(token, totp) {
      if (totp == '') {
        this.$auth
          .login({
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Basic ' + Base64.encode(this.data.body.email + ':' + this.data.body.password + ':' + token + ':' + totp),
            },
            // redirect: {
            //   name: 'Dashboard | english',
            // },
            // staySignedIn: this.data.body.rememberMe,
          })
          .then(
            response => {
              if (response.data.totp == '') {
                this.is2FASetup = true
                this.showTwoFactorAuthStep2()
              } else {
                this.is2FASetup = false
                this.check2FA(response.data.totp)
              }
              // this['menu/reset']()
              // this.$auth.fetch().then(() => {
              //   this.$bus.$emit('LiveFeedConnect')
              // })
            },
            err => {
              if (err.response) {
                if (err.response.data.meta && err.response.data.meta.messageID) {
                  this.$toasted.error(this.$t(err.response.data.meta.messageID).tTitle())
                } else {
                  this.$toasted.error(err.response.data.detail)
                }
                this.error = err.response.data
                this.$store.state.token = null
              }
            }
          )
      }
    },
    otpPassed() {
      this.validateCaptcha()
    },
    goBack(v) {
      if (v) {
        this.showLoginForm = true
        this.TwoFactorAuthStep1.active = false
        this.TwoFactorAuthStep2.active = false
      } else {
        this.TwoFactorAuthStep1.active = true
        this.TwoFactorAuthStep2.active = false
      }
    },
    backToLogin() {
      this.$auth
        .logout({
          makeRequest: false,
          params: {},
          redirect: '/' + this.Language + '/login',
        })
        .then(() => {
          this['user/reset']()
        })
      this.showLoginForm = true
      this.TwoFactorAuthStep1.active = false
    },
    ...mapActions(['menu/reset', 'logoLoader/set', 'user/reset']),
  },

  filters: {
    json: function (value) {
      return value
    },
  },
}
</script>
